<template>
  <crud-list
    :datasource="datasource"
    :capabilities="capabilities"
    @item-selected="selectedItemTraitements"
    :callRefresh="callRefresh"
    ref="datasourceRef"
  >
    <template #search>
      <search-by
        :datasource="datasource"
        attr="actif"
        :check="true"
        @emitsearchby="emitsearchby"
      />
      <search-by
        :datasource="datasource"
        attr="nom"
        @emitsearchby="emitsearchby"
      />
      <search-by
        :datasource="datasource"
        attr="prenom"
        @emitsearchby="emitsearchby"
      />
      <search-by
        :datasource="datasource"
        attr="idParticipant"
        typeChamp="number"
        @emitsearchby="emitsearchby"
      />
    </template>
    <template #table>
      <datasource-table :datasource="datasource">
        <template #item="{ item }">
          <tr @click="$router.push(datasource.linkTo(item))">
            <td>
              {{ item.id }}
            </td>
            <td>
              {{ item.civilite }}
            </td>
            <td>
              {{ item.name }}
            </td>
            <td>
              {{ dateFormatter(item.dateDeNaissance) }}
            </td>
            <td>
              {{ item.mail }}
            </td>
            <td>
              <v-tooltip bottom v-if="item.mutationEnCours">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    small
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon dark> arrow_forward </v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('participant.demandeMutationEnCours') }}</span>
              </v-tooltip>
            </td>
            <td>
              <v-avatar
                color="teal"
                :style="{ height: '32px', minWidth: '32px', width: '32px' }"
                v-if="item.bilanEnCours"
              >
                <span class="white--text headline">B</span>
              </v-avatar>
            </td>
          </tr>
        </template>
      </datasource-table>
    </template>
  </crud-list>
</template>

<script>
import Datasource from '@/utils/datasource'
import dateFormatter from '@/plugins/mixins/DateFormatter'

export default {
  mixins: [dateFormatter],
  props: {
    fieldName: {
      type: String,
      default: '_link',
    },
    capabilities: {
      type: String,
      default: 'create,search',
    },
    rowsSize: {
      type: Number,
      default: 15,
    },
    callRefresh: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    this.$nextTick(function () {
      // this.datasource.args.idTechnique = this.$auth.idTechnique();
      this.datasource.refresh()
    })
  },
  data() {
    const datasource = new Datasource('adherentsCorrespondant', {
      page: 1,
      rowsPerPage: this.rowsSize,
      sortBy: 'id',
      descending: false,
      args: { actif: true },
      customRowClass: (item) => (item.actif ? '' : 'inactive-item'),
      linkClass: (item) => (item.actif ? '' : 'inactif'),
      fields: [
        {
          value: 'id',
          text: this.$t('adherents.list.headers.id'),
          linkTo: this.linkTo,
          sortable: true,
        },
        {
          value: 'civilite',
          text: this.$t('adherents.list.headers.civilite'),
          sortable: true,
        },
        {
          value: 'name',
          text: this.$t('adherents.list.headers.name'),
          sortable: true,
        },
        {
          value: 'dateDeNaissance',
          text: this.$t('adherents.list.headers.dateDeNaissance'),
          sortable: true,
        },
        {
          value: 'mail',
          text: this.$t('adherents.list.headers.mail'),
          sortable: true,
        },
        {
          value: 'mutationEnCours',
          text: this.$t('adherents.list.headers.mutation'),
          sortable: true,
        },
        {
          value: 'bilanEnCours',
          text: this.$t('adherents.list.headers.bilan'),
          sortable: false,
        },
      ],
    })
    return {
      datasource,
    }
  },
  methods: {
    selectedItemTraitements(item) {
      this.$emit('item-selected', item)
    },

    emitsearchby(attr, value) {
      this.datasource.args[attr] = value
    },
  },
}
</script>
